module.exports = __webpack_public_path__ + "static/media/SGInnovate_new.fd186e44.png";